import PropTypes from 'prop-types';

export const { number, string, func, arrayOf, bool, node } = PropTypes;
